"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var useEdularModulesContext_1 = require("./useEdularModulesContext");
function EdularModulesProvider(_a) {
    var _this = this;
    var children = _a.children;
    var _b = (0, react_1.useState)([]), modules = _b[0], setModules = _b[1];
    var _c = (0, react_1.useState)(true), isLoading = _c[0], setIsLoading = _c[1];
    var options = (0, react_1.useRef)();
    var getModules = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!options.current) {
                        return [2];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsLoading(true);
                    return [4, axios_1["default"].post("".concat(options.current.baseUrl, "/v1/module-options/list"), {}, {
                            timeout: 10000,
                            headers: {
                                authorization: options.current.token,
                                'x-profile-id': "".concat(options.current.profileId)
                            }
                        })];
                case 2:
                    data = (_a.sent()).data;
                    setModules(data.data);
                    return [3, 5];
                case 3:
                    error_1 = _a.sent();
                    console.log('Get modules error', error_1.message);
                    return [3, 5];
                case 4:
                    setIsLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); }, []);
    var initialize = (0, react_1.useCallback)(function (opt) {
        options.current = opt;
        getModules();
    }, []);
    var availableModules = (0, react_1.useMemo)(function () {
        return modules.reduce(function (acc, item) {
            if (item.access) {
                acc.push(item);
                if (item.children) {
                    acc.push.apply(acc, item.children.filter(function (c) { return !!c.access; }));
                }
            }
            return acc;
        }, []);
    }, [modules]);
    var isModuleEnable = (0, react_1.useCallback)(function (moduleId) {
        return availableModules.length > 0 &&
            availableModules.some(function (module) { return module.moduleId === moduleId; });
    }, [availableModules]);
    var getModule = (0, react_1.useCallback)(function (moduleId) {
        return availableModules.find(function (module) { return module.moduleId === moduleId; });
    }, [availableModules]);
    var context = (0, react_1.useMemo)(function () { return ({
        isModuleEnable: isModuleEnable,
        refreshModules: getModules,
        initialize: initialize,
        getModule: getModule,
        isLoading: isLoading
    }); }, [isModuleEnable, getModules, initialize, getModule, isLoading]);
    return (react_1["default"].createElement(useEdularModulesContext_1.EdularModulesContext.Provider, { value: context }, children));
}
exports["default"] = EdularModulesProvider;
